import { http } from "config/http";

interface obj_type {
    other: string
}
interface butter_pie_configuration_type {
    client_env: string | null,
    is_update: boolean,
    user_name: string,
    niche_interests: {
        niche_topics: (string | obj_type)[],
        unique_expertise: string,
        content_focus: string
    },
    goals_motivation: {
        creator_why: string[],
        career_goals: string,
        success_definition: (string | obj_type)[]
    },
    skills_background: {
        creation_skills: (string | obj_type)[],
        comfort_level: string[],
        past_experience: string
    },
    preferred_platforms: {
        platform_preference: string[],
        content_format: string,
        multichannel_strategy: string
    },
    available_resources_commitment: {
        time_commitment: string,
        budget: string,
        learning_willingness: string
    },
    monetization_business_goals: {
        monetization_timing: string,
        revenue_streams: string[],
        existing_business: string
    },
    strengths_weaknesses: {
        natural_talents: string,
        struggle_areas: string,
        obstacles: string
    },
    comfort_with_ai_tech: {
        ai_tools_openness: string,
        workflow_automation: string,
        seo_algorithms: string
    }
}

export const addOrUpdateButterPieConfigurations = async (data: butter_pie_configuration_type) => {
    try {
        const res: any = await http.post(`butter_pie_configuration`, data)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getButterPieConfigurations = async (data: string) => {
    try {
        const res: any = await http.get(`get_butter_pie_configurations?client_env=${localStorage.getItem('clientName')}&user_name=${data}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const regenerateCategory = async (data: string, categoryName: string) => {
    try {
        const res: any = await http.get(`regenerate_category?client_env=${localStorage.getItem('clientName')}&user_name=${data}&category_name=${categoryName}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getCategory = async (name: string) => {
    try {
        const res: any = await http.get(`generate_category?client_env=${localStorage.getItem('clientName')}&user_name=${name}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

interface pdf_type {
    client_env: string | null,
    user_name: string | null
}
export const generateButterPiePdf = async (data: pdf_type) => {
    try {
        const res: any = await http.post(`generate_pdf`, data)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}
